<template>
  <div>
    <sessions />
  </div>
</template>

<script>
import sessions from "@/components/sessions";
export default {
  name: "sessions-view",
  components: {
    sessions
  }
};
</script>
